module.exports = __webpack_public_path__ + "media/images/vector-down-0e572c54e5a970637256a54d1b1cf928.svg";